import { ValueOf } from './util';

/** 有効期限タイプのenum */
export const EExpiredPattern = {
  DAYS_LATER: '付与日からN日後',
  MONTHS_LATER_MONTH_END: '付与日からNヶ月後の月末',
  YEARS_LATER_SPECIFIC_MONTH_END: '付与日からN年後の指定月の月末',
  SPECIFICATION: '期日指定',
  INDEFINITE: '無期限',
  BONUS_VALUE_CARD_EXPIRE: 'ボーナスバリューの有効期限設定に従う',
} as const;

export type ExpiredPatternKey = keyof typeof EExpiredPattern;
export type ExpiredPatternValue = ValueOf<typeof EExpiredPattern>;

export const expiredPatternKeys = Object.keys(EExpiredPattern) as (ExpiredPatternKey[]);

/** v-select用items */
export const expiredPatternItems = expiredPatternKeys
  .map((key) => ({
    title: EExpiredPattern[key],
    value: key,
  }));
